export const GET_PATIENT_FORMS = 'GET_PATIENT_FORMS';
export const ADD_PATIENT_FORM = 'ADD_PATIENT_FORM';
export const REPLACE_PATIENT_FORM = 'REPLACE_PATIENT_FORM';
export const REMOVE_PATIENT_FORM = 'REMOVE_PATIENT_FORM';
export const GET_PATIENT_FORM_STRUCTURE = 'GET_PATIENT_FORM_STRUCTURE';
